
import React, { useEffect, useState } from "react";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { Link, useLocation } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import useApi from "../../../core/customhook/useApi";
import Loader from "../../../core/common/selfLoder";
import Table from "../../../core/common/dataTable/index";
import { getFinancialYearList } from "../../../core/common/financialYear";

const TeamLeaveBalance = () => {
  const location = useLocation();
  const employee_id = location.state?.searchValue?.employee_id;



  const formatFinancialYear = (year: number) => {
    const nextYearShort = (year + 1).toString().slice(-2);
    return `${year}-${nextYearShort}`;
  };

  const getFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    return formatFinancialYear(year);
  };

  const [finance_year, setFinance_year] = useState(getFinancialYear());

  // API call
  const {
    data: team_leave_summaryData,
    loading: team_leave_summaryloading,
    error: team_leave_summaryerror,
  } = useApi("/api/manager/team-leave-summary", {
    method: "POST",
    payload: {
      financial_year: finance_year,
    },
    autoCall: true,
    dependencies: [finance_year],
  });



  const leaveTypesOrder = [
    "Earned Leave",
    "Sick Leave",
    "Restricted Holiday",
    "Maternity Leave",
    "Paternity leave",
    "Leave Without Pay",
    "Short Leave",
    "Bereavement Leave",
    "Wedding Leave",
    "Happiness Leave",
  ];


  // ✅ Apply filter: if employee_id exists → filter API data
  const filteredData = employee_id
    ? team_leave_summaryData?.data?.filter(
      (emp: any) => emp.employee_id === employee_id
    )
    : team_leave_summaryData?.data;

  // 🔹 Transform API response → Table Data
  const tableData =
    filteredData?.map((item: any, index: number) => {
      // Build a lookup for leave_summary
      const leaveMap: Record<string, string> = {};
      item.leave_summary.forEach((leave: any) => {
        const openingSum =
          (parseFloat(leave.opening_balance) || 0) +
          (parseFloat(leave.prorata_balance) || 0);
        const closing = parseFloat(leave.closing_balance) || 0;

        leaveMap[leave.leave_type] = `${closing.toFixed(
          2
        )} / ${openingSum.toFixed(2)} `;
      });

      // Calculate total (sum of current_balance)
      const totalLeaves = item.leave_summary.reduce(
        (sum: number, leave: any) => sum + (leave.current_balance || 0),
        0
      );

      return {
        key: index + 1,
        employee_details: `${item.employee_name} (${item.designation})`,
        department: item.department || "-",
        location: item.location || "-",
        total: `${totalLeaves} Days`, // ✅ show with "Days"
        // Spread all leave types dynamically in fixed order
        ...leaveTypesOrder.reduce((acc, leaveType) => {
          const key = leaveType.toLowerCase().replace(/\s+/g, "_");
          acc[key] = leaveMap[leaveType] ?? `0/0`;
          return acc;
        }, {} as Record<string, string>),
        status: item.status || "PENDING",
      };
    }) || [];



  // 🔹 Columns (proper leave order)
  const columns = [
    { title: "Employee Details", dataIndex: "employee_details", sorter: (a: any, b: any) => a.employee_details.localeCompare(b.employee_details), },
    { title: "Department", dataIndex: "department", sorter: (a: any, b: any) => a.department.localeCompare(b.department), align: "center" },
    { title: "Location", dataIndex: "location", sorter: (a: any, b: any) => a.location.localeCompare(b.location) },
    // { title: "Total", dataIndex: "total", sorter: (a: any, b: any) => a.total - b.total, align: "center" },
    { title: "Earned Leave", dataIndex: "earned_leave", sorter: (a: any, b: any) => a.earned_leave - b.earned_leave, align: "center" },
    //     {
    //   title: "Earned Leave",
    //   dataIndex: "earned_leave",
    //   align: "center",
    //   sorter: (a: any, b: any) => {
    //     // Sort by closing balance as number
    //     const aClosing = parseFloat(a.earned_leave.closing_balance) || 0;
    //     const bClosing = parseFloat(b.earned_leave.closing_balance) || 0;
    //     return aClosing - bClosing;
    //   },
    // render: (item: any) => {
    //   console.log(item, "item is here");

    //   const openingSum = (parseFloat(item.opening_balance) || 0) + (parseFloat(item.prorata_balance) || 0);
    //   const closing = parseFloat(item.closing_balance) || 0;

    //   return `${openingSum.toFixed(2)} / ${closing.toFixed(2)}`;
    // },

    // },

    { title: "Sick Leave", dataIndex: "sick_leave", sorter: (a: any, b: any) => a.sick_leave - b.sick_leave, align: "center" },
    { title: "Restricted Holiday", dataIndex: "restricted_holiday", sorter: (a: any, b: any) => a.restricted_holiday - b.restricted_holiday, align: "center" },


    // { title: "Maternity Leave", dataIndex: "maternity_leave", sorter: (a: any, b: any) => a.maternity_leave - b.maternity_leave, align: "center" },
    // { title: "Paternity Leave", dataIndex: "paternity_leave", sorter: (a: any, b: any) => a.paternity_leave - b.paternity_leave, align: "center" },
    // { title: "Short Leave", dataIndex: "short_leave", sorter: (a: any, b: any) => a.short_leave - b.short_leave, align: "center" },
    // { title: "Bereavement Leave", dataIndex: "bereavement_leave", sorter: (a: any, b: any) => a.bereavement_leave - b.bereavement_leave, align: "center" },
    // { title: "Wedding Leave", dataIndex: "wedding_leave", sorter: (a: any, b: any) => a.wedding_leave - b.wedding_leave, align: "center" },
    // { title: "Happiness Leave", dataIndex: "happiness_leave", sorter: (a: any, b: any) => a.happiness_leave - b.happiness_leave, align: "center" },
    // { title: "Leave Without Pay", dataIndex: "leave_without_pay", sorter: (a: any, b: any) => a.leave_without_pay - b.leave_without_pay, align: "center" },

    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   render: (text: string) => (
    //     <span
    //       className={`badge ${text.toLowerCase().includes("approved")
    //         ? "bg-success"
    //         : text.toLowerCase().includes("rejected")
    //           ? "bg-danger"
    //           : "bg-warning"
    //         }`}
    //     >
    //       {text}
    //     </span>
    //   ),
    //   sorter: (a: any, b: any) => a.status.localeCompare(b.status),
    // },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Breadcrumb */}
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-2">
          <div className="my-auto mb-2">
            <h2 className="mb-2">Team Leave Balance</h2>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={all_routes.employeeDashboard}>
                    <i className="ti ti-smart-home" />
                  </Link>
                </li>
                <li className="breadcrumb-item">Work & Operations</li>
                <li className="breadcrumb-item">Team Leave</li>
                <li className="breadcrumb-item active" aria-current="page">
                  Team Leave Balance
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
            <div>
              <Link to="/leave-team-member" className="btn btn-primary custom_button py-1 px-3">
                Back
              </Link>
            </div>
            <div className="me-2 mb-2"></div>
            <div className="input-icon w-120 position-relative mb-2">
              <span className="input-icon-addon">
                <i className="ti ti-calendar text-gray-9" />
              </span>

              <select
                value={finance_year}
                onChange={(e) => setFinance_year(e.target.value)}
                className="form-select"
              >
                {getFinancialYearList().map((fy) => (
                  <option key={fy} value={fy}>
                      {fy.split("-")[0]}
                    </option>
                ))}
              </select>

            </div>
            <div className="head-icons ms-2">
              <CollapseHeader />
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="card">
          <div className="card-body p-0">
            <Loader loading={team_leave_summaryloading} />
            <Table dataSource={tableData} columns={columns} Selection={false} showSearchInput={true} />
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
        <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
      </div>
    </div>
  );
};

export default TeamLeaveBalance;

